"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var base_1 = require("@bhtp-client-api/base");
var ApiEditPolicy = (function (_super) {
    __extends(ApiEditPolicy, _super);
    function ApiEditPolicy() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return ApiEditPolicy;
}(base_1.ApiPolicy));
exports.ApiEditPolicy = ApiEditPolicy;
//# sourceMappingURL=D:/a/1/s/edit/src/models/edit-policy.model.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/edit/src/models/edit-policy.model.js